/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_User_Lastname_Placeholder1Inputs */

const es_co2_signup_user_lastname_placeholder1 = /** @type {(inputs: Signup_User_Lastname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pérez`)
};

/**

* @param {Signup_User_Lastname_Placeholder1Inputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
const signup_user_lastname_placeholder1 = /** @type {((inputs?: Signup_User_Lastname_Placeholder1Inputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_User_Lastname_Placeholder1Inputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_user_lastname_placeholder1(inputs)
});
export { signup_user_lastname_placeholder1 as "signup_user_lastName_placeholder" }